import React from 'react';
import _isEmpty from 'lodash/isEmpty';

import { FormattedMessage } from '@kyruus/intl';
import { Alert } from '@biome-design-system/ui/Alert';
import { Typography } from '@biome-design-system/ui/Typography';
import { List } from '@biome-design-system/ui/List';

import { type Log, type SearchLink, type GetUpdatedSearch } from 'Src/types';
import { messages } from './messages';
import { SearchSuggestions } from './SearchSuggestions';

interface SuggestionsProps {
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
  suggestions: SearchLink[];
}

export const Suggestions = ({
  getUpdatedSearch,
  log,
  suggestions
}: SuggestionsProps) => {
  const showSuggestions = _isEmpty(suggestions) === false;

  if (!showSuggestions) return null;

  return (
    <Alert severity="info" variant="outlined" icon={false}>
      <FormattedMessage {...messages.suggestionsHeader}>
        {(message) => (
          <Typography id="suggestions-header" component="h3" variant="h5">
            {message}
          </Typography>
        )}
      </FormattedMessage>
      <List
        data-testid="noResults.suggestions"
        aria-labelledby="suggestions-header"
        sx={{
          listStyleType: 'disc',
          pl: 2,
          li: { display: 'list-item', pl: 1 }
        }}
      >
        {showSuggestions && (
          <SearchSuggestions
            suggestions={suggestions}
            getUpdatedSearch={getUpdatedSearch}
            log={log}
          />
        )}
      </List>
    </Alert>
  );
};
